var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Da ist ein Fehler aufgetreten - das sollte nicht passieren."),_c('br'),_vm._v(" Bitte laden Sie die Seite erneut oder probieren Sie es später erneut. ")])
}]

export { render, staticRenderFns }